import { GetCollectionsCollectionAttributesAllV4Response } from '@/lib/reservoir/reservoir.generated';

export enum CollectionSectionType {
  NFT_GALLERY = 'NFT_GALLERY',
  TITLE_AND_TEXT = 'TITLE_AND_TEXT',
  VIDEO_AND_IMAGE = 'VIDEO_AND_IMAGE',
  TEXT_AND_IMAGE = 'TEXT_AND_IMAGE',
  VIDEO = 'VIDEO',
  IMAGE_COLLECTION = 'IMAGE_COLLECTION',
  TEXT = 'TEXT',
}

export enum CollectionMediaType {
  THUMBNAIL = 'THUMBNAIL',
  LOGO = 'LOGO',
  ROUNDED_LOGO = 'ROUNDED_LOGO',
  BACKGROUND = 'BACKGROUND',
  ASSET = 'ASSET',
}

export enum CollectionAttributeKind {
  SHORT_TEXT = 'SHORT_TEXT',
  LONG_TEXT = 'LONG_TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  DATE_DISTANCE = 'DATE_DISTANCE',
  HIDDEN = 'HIDDEN',
}

export type ReservoirAttributeKind = NonNullable<
  GetCollectionsCollectionAttributesAllV4Response['attributes']
>[number]['kind'];

export const attributeMap: Record<ReservoirAttributeKind, CollectionAttributeKind> = {
  date: CollectionAttributeKind.DATE,
  number: CollectionAttributeKind.NUMBER,
  string: CollectionAttributeKind.SHORT_TEXT,
  range: CollectionAttributeKind.NUMBER,
};
